import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute top-2 left-1.5 origin-0 fixed-label" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "name", "value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mdc-radio__background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mdc-radio__outer-circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "mdc-radio__inner-circle" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mdc-radio__ripple" }, null, -1)
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock("label", {
          class: _normalizeClass(["relative flex my-0 max-h-screen space-x-0 cursor-pointer items-start radio-item", { 'radio-container': !_ctx.disabled }]),
          key: _ctx.id + '-option-' + index
        }, [
          _createElementVNode("div", {
            id: _ctx.id + '-radio-' + index,
            class: "mdc-radio"
          }, [
            _createElementVNode("input", {
              id: _ctx.id + '-radio-' + index + '-native',
              class: "mdc-radio__native-control",
              type: "radio",
              name: _ctx.id,
              value: option.value
            }, null, 8, _hoisted_5),
            _hoisted_6,
            _hoisted_7
          ], 8, _hoisted_4),
          _createElementVNode("label", {
            class: "mt-2 cursor-pointer",
            for: _ctx.id + '-radio-' + index + '-native'
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", {
                  class: "",
                  innerHTML: option.content
                }, null, 8, _hoisted_11),
                _renderSlot(_ctx.$slots, "itemSide", { option: option })
              ]),
              _renderSlot(_ctx.$slots, "item", {
                description: option.description
              })
            ])
          ], 8, _hoisted_8)
        ], 2))
      }), 128))
    ])
  ]))
}